function OAuthGuideModal({ onClose, onStart }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: '#1a1a2e', borderRadius: '20px', padding: '36px',
        maxWidth: '560px', width: '100%', maxHeight: '85vh', overflowY: 'auto',
        border: '1px solid #2a2a4a', boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
      }} onClick={e => e.stopPropagation()}>

        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>&#128279;</div>
          <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#fff', marginBottom: '8px' }}>
            인스타그램 연결 전 확인사항
          </h3>
          <p style={{ fontSize: '14px', color: '#9d9db9' }}>
            아래 조건이 모두 준비되어야 연결이 정상적으로 완료됩니다.
          </p>
        </div>

        {[
          {
            num: '1',
            title: 'Instagram 비즈니스 또는 크리에이터 계정',
            desc: 'Instagram 앱 → 설정 → 계정 → 프로페셔널 계정으로 전환',
            color: '#E1306C'
          },
          {
            num: '2',
            title: 'Facebook 페이지 생성',
            desc: 'Facebook에서 비즈니스 페이지를 생성해야 합니다. (개인 프로필 X)',
            color: '#1877F2'
          },
          {
            num: '3',
            title: 'Instagram 계정과 Facebook 페이지 연결',
            desc: 'Instagram 앱 → 설정 → 계정 → 연결된 계정 → Facebook → 페이지 선택',
            color: '#833AB4'
          },
          {
            num: '4',
            title: 'Facebook 페이지 관리자 권한',
            desc: '로그인할 Facebook 계정이 해당 페이지의 관리자여야 합니다.',
            color: '#4267B2'
          }
        ].map((item) => (
          <div key={item.num} style={{
            display: 'flex', gap: '16px', padding: '16px',
            background: '#12122a', borderRadius: '12px', marginBottom: '12px',
            border: '1px solid #2a2a4a'
          }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '50%',
              background: item.color, color: '#fff', flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '16px', fontWeight: '700'
            }}>{item.num}</div>
            <div>
              <div style={{ fontSize: '15px', fontWeight: '700', color: '#fff', marginBottom: '4px' }}>
                {item.title}
              </div>
              <div style={{ fontSize: '13px', color: '#9d9db9', lineHeight: '1.5' }}>
                {item.desc}
              </div>
            </div>
          </div>
        ))}

        <div style={{
          marginTop: '20px', padding: '14px 16px',
          background: '#1e1e3a', borderRadius: '10px',
          border: '1px solid #3a3a5a'
        }}>
          <div style={{ fontSize: '13px', color: '#fbbf24', fontWeight: '600', marginBottom: '6px' }}>
            &#9888; 주의
          </div>
          <div style={{ fontSize: '13px', color: '#9d9db9', lineHeight: '1.6' }}>
            위 조건이 준비되지 않으면 Facebook 로그인은 성공하지만,
            Instagram 계정을 찾을 수 없다는 오류가 발생합니다.
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '28px' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1, padding: '14px', borderRadius: '12px',
              border: '1px solid #3a3a5a', background: 'transparent',
              color: '#9d9db9', fontSize: '15px', fontWeight: '600', cursor: 'pointer'
            }}
          >
            취소
          </button>
          <button
            onClick={onStart}
            style={{
              flex: 2, padding: '14px', borderRadius: '12px', border: 'none',
              background: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)',
              color: '#fff', fontSize: '15px', fontWeight: '700', cursor: 'pointer'
            }}
          >
            모두 준비됨 - 연결 시작
          </button>
        </div>
      </div>
    </div>
  );
}

export default OAuthGuideModal;
